const List = () => import(/* webpackChunkName: "componente-utilizacao-bundle" */ './main.vue');

export default [
  {
    name: 'relatorio/componente-utilizacao',
    path: '/relatorio/componente-utilizacao',
    components: { default: List },
    meta: {
      requiresAuth: true,
      breadcrum: 'Componente Utilização dos Serviços',
      icon: 'file-pdf',
      can: 'rep279',
      on: 'report',
    },
  },
];
